import { render, staticRenderFns } from "./OrderPrefix.vue?vue&type=template&id=0341d4c2&scoped=true"
import script from "./OrderPrefix.vue?vue&type=script&lang=js"
export * from "./OrderPrefix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341d4c2",
  null
  
)

export default component.exports